// extracted by mini-css-extract-plugin
export default {"modal":"modalSelector_modal__LSkII","close":"modalSelector_close__xNU8D","product_wrapper":"modalSelector_product_wrapper__v+iWV","checkbox":"modalSelector_checkbox__Uyytx"};